import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/(accounts)/forgot-password/_components/ForgotPassword.tsx");
